import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import InfoContent from '../InfoContent';

import styles from '../index.styl';

const Info = ({ value }) => (
  <div styleName="info">
    <InfoContent value={value} />
  </div>
);

Info.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]).isRequired,
};

export default CSSModules(Info, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/InfoBtn/Info/index.jsx